import Rollbar from 'rollbar';

class RollbarService {
  initialize(appConfig) {
    const environment = appConfig.get('environment');
    const accessToken = appConfig.get('rollbar_client_access_token');
    const enabled = environment === 'production';

    this.rollbar = new Rollbar({
      accessToken,
      environment,
      enabled,
      captureUncaught: true,
      captureUnhandledRejections: true,
      payload: {
        client: {
          javascript: {
            source_map_enabled: true,
            guess_uncaught_frames: true,
          },
        },
      },
      autoInstrument: {
        network: true,
        log: true,
        dom: true,
        navigation: true,
        connectivity: true,
        networkResponseHeaders: true,
      },
      scrubTelemetryInputs: true,
    });
  }

  error(error) {
    return this.rollbar.error(error);
  }
}

export default new RollbarService();
